import templateUrl from "emun.invoice/credit-request/credit-request-line-image.htm";
import directive from "emun.invoice/credit-request/credit-request-line.directive";

export default directive(templateUrl);

